var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackAtom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 103,
    viewBox: "0 0 105 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.6137 83.449C77.181 79.6575 74.2324 62.2551 64.0278 44.5796C53.8232 26.9041 40.2268 15.649 33.6595 19.4405C27.0922 23.232 30.0409 40.6345 40.2455 58.3099C50.4501 75.9854 64.0464 87.2405 70.6137 83.449Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1447 65.1629C72.5544 65.1627 89.0996 59.015 89.0995 51.4318C89.0994 43.8486 72.554 37.7014 52.1443 37.7017C31.7346 37.7019 15.1893 43.8496 15.1894 51.4328C15.1895 59.016 31.7349 65.1632 52.1447 65.1629Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6677 83.4471C40.2351 87.2388 53.8319 75.9836 64.0369 58.3079C74.242 40.6322 77.1909 23.2294 70.6235 19.4377C64.0561 15.646 50.4594 26.9013 40.2543 44.577C30.0492 62.2527 27.1003 79.6554 33.6677 83.4471Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6361 55.7884C52.0364 57.1742 55.1056 56.3519 56.4914 53.9515C57.8772 51.5512 57.0548 48.482 54.6545 47.0961C52.2542 45.7103 49.185 46.5328 47.7992 48.9331C46.4133 51.3334 47.2357 54.4026 49.6361 55.7884Z",
    fill: "#80FFAF",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackAtom1);
export default __webpack_public_path__ + "static/media/feedback-atom-1.be96f8b5008cde7684044215dfe7c876.svg";
export { ForwardRef as ReactComponent };